import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import { DownloadOutlined } from "@ant-design/icons";
import "./ChartConfig";

const GrievanceBarChart = ({index, title, dataSource }) => {
  const chartRef = useRef(null);

  const backgroundColors = [
    "#A6E5FC", "#F8A4A7", "#BDBBF8", "#70A5FC", "#fbdc7f", "#93ddf6", 
    "#b4695e", "#c8acf6", "#9ED8FF", "#7590c7"
  ];

  if(!dataSource) return;

  const data = {
    labels: dataSource.map(item => `${item.Bracket}`),
    datasets: [
      {
        label: "Percentage",
        data: dataSource.map(item => item.Percentage),
        backgroundColor: backgroundColors, // Red
        borderColor: backgroundColors,
        borderWidth: 1,
        borderRadius: { topLeft: 5, topRight: 5, bottomLeft: 0, bottomRight: 0 },
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: title,
      },
      datalabels: {
        color: "white",
        font: {
          weight: "bold",
        },
        formatter: (value) => {
          return `${Number(value).toFixed(2)}%`;
        },
      },
    },
    scales: {
      x: {
        title: {
            display: true,
            text: "Bracket",
          },
      },
       y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Percentage (%)",
        },
      }
    },
  };


  const downloadChart = (format) => {
    if (chartRef.current) {
      const chartInstance = chartRef.current;
      const url = chartInstance.toBase64Image(format); // Convert to Base64
      const link = document.createElement("a");
      link.href = url;
      link.download = `${title.split(' ').join('-')}.${format === "image/png" ? "png" : "jpg"}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };


  return (
    <div className="bar-chart" style={{ width: "100%", overflowX: "auto", height: "auto" }}>
      <div style={{ minWidth: "600px", minHeight: "400px" }}>
        <div className="download-graph" onClick={() => downloadChart("image/png")}><DownloadOutlined /></div>
        <Bar key={index} ref={chartRef} data={data} options={options} />
      </div>
    </div>
  )
};

export default GrievanceBarChart;
